import classNames from '@/utils/classnames';

import { SESSION_PHASE_PILL, type SessionPhase } from './session-status';

/** A session's phase as a dot-and-word pill — the session list rows and both session headers. */
export function SessionStatusPill({ phase }: { phase: SessionPhase }) {
  const pill = SESSION_PHASE_PILL[phase];
  return (
    <span
      className={classNames('flex items-center gap-1.5 rounded-full px-2.5 py-1 text-2xs font-semibold', pill.wrap)}
    >
      <span className={classNames('size-1.75 rounded-full', pill.dot)} />
      {pill.label}
    </span>
  );
}
